/**
 * Convercus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StatusLevelData } from './status-level-data';
import { StatusLevelSetDataMetricConfiguration } from './status-level-set-data-metric-configuration';


export interface StatusLevelSetData { 
    metricConfiguration: StatusLevelSetDataMetricConfiguration;
    status: StatusLevelSetData.StatusEnum;
    statusLevels: Array<StatusLevelData>;
}
export namespace StatusLevelSetData {
    export type StatusEnum = 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        ACTIVE: 'ACTIVE' as StatusEnum,
        INACTIVE: 'INACTIVE' as StatusEnum
    };
}


